import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Row, Col, Input } from 'antd';
import { isEmpty } from 'utils/utils';

export interface ProjectMemoEditModalProps extends PopupProps {
    id: number
    project: string;
    company: string;
    created_at: string;
    memo: string;
}

const ProjectMemoEditModal = ({ 
    isOpen, 
    onClose, 
    id = 0,
    project = '',
    company = '',
    created_at = '',
    memo = '',
 }: ProjectMemoEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [isFormDone, setIsFormDone] = useState<boolean>(false);
   /* ======================================================
   * variables
   * ====================================================== */
   const [form] = Form.useForm();
   const { TextArea } = Input;
   /* ======================================================
   * events
   * ====================================================== */
   const onChangeForm = () => { 
        setIsFormDone(!isEmpty(form.getFieldValue('memo')));
    };  

    const onSubmit = (e) => {
        onClose?.(true, id, e.memo);
    };

    const onCancel = () => {
        onClose?.(false);
    };
  /* ======================================================
   * hooks
   * ====================================================== */

   
  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    form.setFieldValue("memo", memo);
  }, [memo]);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={600} title={'참고사항'} closable>
            <Form
                form={form}
                name="RefCode"
                layout="horizontal"  
                labelCol={{ flex: '100px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Row>
                    <Col span={12}>
                        <Form.Item label={'기업명'}>
                            <label>{company}</label>                  
                        </Form.Item>   
                    </Col> 
                    <Col span={12}> 
                        <Form.Item label={'등록일시'}>
                            <label>{created_at}</label>                  
                        </Form.Item>    
                    </Col>            
                </Row>
                <Form.Item label={'프로젝트명'}>
                    <label>{project}</label>                  
                </Form.Item>   
                <Form.Item name="memo" label={'참고사항 메모'}>
                    <TextArea rows={3} placeholder='참고사항 메모를 입력하세요'/>                  
                </Form.Item>            
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!isFormDone}>{id===0?'등록':'수정'}</Button>
                </ButtonGroup>                
            </Form>   
        </ModalWrapper>  
    )    
};

export default React.memo(ProjectMemoEditModal);    